// Header.js - PART 1/2

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FiPhone,
  FiGlobe,
  FiMenu,
  FiX,
  FiChevronRight,
} from "react-icons/fi";

/* ================================
   HEADER WRAPPER
================================ */

const HeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99999;

  /* Smooth slide up/down animation */
  transform: ${({ $visible }) =>
    $visible ? "translateY(0)" : "translateY(-100%)"};
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);

  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.08);
`;


/* ================================
   CONTAINER
================================ */

const Container = styled.div`
  max-width: 1280px;
  margin: auto;

  padding: 14px 32px;

  display: flex;
  align-items: center;
  justify-content: space-between;


  @media(max-width:${({theme})=>theme.breakpoints.tablet}){

    padding:14px 18px;

  }


  @media(max-width:${({theme})=>theme.breakpoints.mobile}){

    padding:12px 16px;

  }
`;



/* ================================
   BRAND
================================ */


const Brand = styled.a`

display:flex;
align-items:center;
gap:12px;

cursor:pointer;
text-decoration:none;


`;



const LogoBox = styled.div`
  width: 52px;
  height: 52px;

  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;

  overflow: hidden;

  box-shadow: 0 8px 20px rgba(15, 139, 66, 0.25);

  transition: 0.3s;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 12px 30px rgba(15, 139, 66, 0.35);
  }
`;




const BrandText = styled.div`

display:flex;

flex-direction:column;


h1{

font-family:${({theme})=>theme.fonts.english};

font-size:1.05rem;

font-weight:800;

letter-spacing:.3px;

color:${({theme})=>theme.colors.textDark};

line-height:1.2;

}


span{

font-size:.7rem;

font-weight:600;

letter-spacing:.08em;

text-transform:uppercase;

color:${({theme})=>theme.colors.textMuted};

margin-top:3px;

}


`;



/* ================================
   DESKTOP NAVIGATION
================================ */


const Navigation = styled.nav`

display:flex;

align-items:center;

gap:6px;


@media(max-width:${({theme})=>theme.breakpoints.desktop}){

display:none;

}


`;




const NavLink = styled.a`

position:relative;

padding:10px 16px;

border-radius:50px;

font-size:.875rem;

font-weight:600;

color:${({theme})=>theme.colors.textDark};


text-decoration:none;


transition:${({theme})=>theme.transitions.default};


&:hover{

background:${({theme})=>theme.colors.primaryLight};

color:${({theme})=>theme.colors.primary};

}



${({active,theme})=>active && `

background:${theme.colors.primaryLight};

color:${theme.colors.primary};


`}


`;




/* ================================
   ACTION BUTTONS
================================ */


const Actions = styled.div`

display:flex;

align-items:center;

gap:12px;


@media(max-width:${({theme})=>theme.breakpoints.desktop}){

display:none;

}

`;



const LanguageButton = styled.button`

height:40px;

padding:0 15px;


display:flex;

align-items:center;

gap:8px;


background:white;

border:

1px solid ${({theme})=>theme.colors.border};


border-radius:50px;


font-size:.8rem;

font-weight:700;


color:${({theme})=>theme.colors.textDark};



&:hover{

border-color:${({theme})=>theme.colors.primary};

color:${({theme})=>theme.colors.primary};

background:${({theme})=>theme.colors.primaryLight};

}


`;




const CallButton = styled.a`

height:44px;

padding:0 20px;


display:flex;

align-items:center;

gap:8px;


border-radius:50px;


background:

linear-gradient(
135deg,
${({theme})=>theme.colors.primary},
${({theme})=>theme.colors.secondary}
);


color:white;


font-weight:700;

font-size:.85rem;


box-shadow:

0 8px 20px rgba(0,131,184,.25);


text-decoration:none;


transition:.3s;



&:hover{

transform:translateY(-3px);

color:white;

box-shadow:

0 12px 25px rgba(0,131,184,.35);

}


`;



/* ================================
   MOBILE MENU BUTTON
================================ */


const MenuButton = styled.button`

display:none;


width:44px;

height:44px;


border-radius:50%;


background:${({theme})=>theme.colors.primaryLight};


color:${({theme})=>theme.colors.primary};


align-items:center;

justify-content:center;


font-size:1.35rem;



@media(max-width:${({theme})=>theme.breakpoints.desktop}){

display:flex;

}


`;



/* ================================
   MOBILE OVERLAY
================================ */


const Overlay = styled.div`

position:fixed;

inset:0;

z-index: 99998;

background:rgba(15,23,42,.35);

backdrop-filter:blur(5px);


opacity:${({open})=>open?1:0};

visibility:${({open})=>open?"visible":"hidden"};


transition:.3s;


@media(min-width:${({theme})=>theme.breakpoints.desktop}){

display:none;

}


`;
// Header.js - PART 2/2


/* ================================
   MOBILE DRAWER
================================ */

const MobileDrawer = styled.aside`

position:fixed;

top:0;
right:0;

height:100vh;

width:min(85vw,380px);
z-index: 100000;


background:${({theme})=>theme.colors.white};


padding:90px 24px 30px;


display:flex;

flex-direction:column;

gap:10px;


transform:${({open})=>
open ? "translateX(0)" : "translateX(100%)"
};


transition:.35s ease;


box-shadow:

-10px 0 30px rgba(15,23,42,.15);



@media(min-width:${({theme})=>theme.breakpoints.desktop}){

display:none;

}


`;



const MobileLink = styled.a`

display:flex;

align-items:center;

justify-content:space-between;


padding:14px 12px;


border-radius:12px;


font-size:1rem;

font-weight:600;


color:${({theme})=>theme.colors.textDark};


text-decoration:none;



&:hover{

background:${({theme})=>theme.colors.primaryLight};

color:${({theme})=>theme.colors.primary};

}


`;



const MobileActions = styled.div`

margin-top:20px;


display:flex;

flex-direction:column;

gap:12px;


`;



const MobileCall = styled(CallButton)`

justify-content:center;

height:48px;


`;





/* ================================
   HEADER COMPONENT
================================ */


export default function Header({
  isArabic,
  setIsArabic
}) {


const [menuOpen,setMenuOpen]=useState(false);

const [visible,setVisible]=useState(true);

const [active,setActive]=useState("home");



/*
 Hide header on scroll down
 Show on scroll up
*/

useEffect(()=>{


let lastScroll=window.scrollY;


const handleScroll=()=>{


const current=window.scrollY;



if(current > lastScroll && current > 120){

setVisible(false);

}
else{

setVisible(true);

}


lastScroll=current;



};



window.addEventListener(
"scroll",
handleScroll,
{passive:true}
);



return ()=>{

window.removeEventListener(
"scroll",
handleScroll
);

};


},[]);





/*
 Active Section Tracking
*/


useEffect(()=>{


const sections=document.querySelectorAll(
"section[id]"
);


const observer=new IntersectionObserver(

(entries)=>{


entries.forEach(entry=>{


if(entry.isIntersecting){

setActive(entry.target.id);

}


});


},


{

rootMargin:"-120px 0px -50%",

threshold:0

}



);



sections.forEach(section=>

observer.observe(section)

);



return ()=>observer.disconnect();



},[]);




/* =========================================================
   Hide header on scroll down, smooth show on scroll up
========================================================= */

useEffect(() => {
  let lastScrollY = window.scrollY;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const scrollDifference = currentScrollY - lastScrollY;

    // 1. Always show header near the top of the page
    if (currentScrollY <= 50) {
      setVisible(true);
      lastScrollY = currentScrollY;
      return;
    }

    // 2. Ignore tiny scroll fluctuations (less than 10px) to avoid jitter
    if (Math.abs(scrollDifference) < 10) {
      return;
    }

    // 3. Hide on scroll down, show on scroll up
    if (scrollDifference > 0 && currentScrollY > 100) {
      // Scrolling Down
      setVisible(false);
    } else if (scrollDifference < 0) {
      // Scrolling Up
      setVisible(true);
    }

    lastScrollY = currentScrollY;
  };

  window.addEventListener("scroll", handleScroll, { passive: true });

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

const navItems=[

{
label:"Home",
id:"home"
},

{
label:"About Us",
id:"about"
},

{
label:"Services",
id:"services"
},

{
label:"Projects",
id:"projects"
},

{
label:"Why Choose Us",
id:"why-choose-us"
},

{
label:"Contact Us",
id:"contact"
}


];





const scrollToSection=(e,id)=>{


e.preventDefault();


setMenuOpen(false);



const element=document.getElementById(id);



if(element){


const offset=90;


const position=

element.getBoundingClientRect().top

+

window.scrollY

-

offset;



window.scrollTo({

top:position,

behavior:"smooth"

});


}


};






return (

<>

<HeaderWrapper $visible={visible}>


<Container>


{/* BRAND */}

<Brand

href="#home"

onClick={(e)=>
scrollToSection(e,"home")
}

>


<LogoBox>
  <img
    src="https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Untitled_design_2_9c75ca29-926d-4f85-94dd-b01cbf3f47a0.png?v=1785696629"
    alt="Jisr Al Sahra Logo"
  />
</LogoBox>


<BrandText>


<h1>
JISR AL SAHRA
</h1>


<span>
Plaster & Tiles Cont.
</span>


</BrandText>


</Brand>





{/* DESKTOP NAV */}


<Navigation>


{

navItems.map(item=>(


<NavLink

key={item.id}

href={`#${item.id}`}

active={
active===item.id
}

onClick={(e)=>
scrollToSection(e,item.id)
}

>

{item.label}


</NavLink>


))


}


</Navigation>





{/* DESKTOP ACTIONS */}


<Actions>


{/* <LanguageButton

onClick={()=>setIsArabic(!isArabic)}

>

<FiGlobe/>

{
isArabic
?
"English"
:
"العربية"
}


</LanguageButton> */}




<CallButton href="tel:+971554688022">


<FiPhone/>

+971 55 468 8022


</CallButton>



</Actions>






{/* MOBILE BUTTON */}



<MenuButton

aria-label="Open menu"

onClick={()=>setMenuOpen(true)}

>

<FiMenu/>


</MenuButton>



</Container>



</HeaderWrapper>





{/* MOBILE OVERLAY */}


<Overlay

open={menuOpen}

onClick={()=>setMenuOpen(false)}

/>






{/* MOBILE DRAWER */}



<MobileDrawer open={menuOpen}>


<MenuButton

style={{
position:"absolute",
top:"20px",
right:"20px"
}}

onClick={()=>setMenuOpen(false)}

>

<FiX/>

</MenuButton>





{

navItems.map(item=>(


<MobileLink

key={item.id}

href={`#${item.id}`}

onClick={(e)=>
scrollToSection(e,item.id)
}

>


{item.label}


<FiChevronRight/>

</MobileLink>


))


}




<MobileActions>


{/* <LanguageButton

onClick={()=>{

setIsArabic(!isArabic);

setMenuOpen(false);

}}

>


<FiGlobe/>


{
isArabic
?
"English"
:
"العربية"
}


</LanguageButton> */}





<MobileCall href="tel:+971554688022">


<FiPhone/>

Call +971 55 468 8022


</MobileCall>



</MobileActions>



</MobileDrawer>


</>


);


}